<template>

    <v-modal title="Add Action">

        <template #nav v-if="campaign.type === 'automatic'">
            <a :class="{ active: collection === 'popular' }" href="#" @click.prevent="collection = 'popular'">Popular</a>
            <a :class="{ active: collection === 'messages' }" href="#" @click.prevent="collection = 'messages'">Messages</a>
            <a :class="{ active: collection === 'alerts' }" href="#" @click.prevent="collection = 'alerts'">Alerts</a>
            <a :class="{ active: collection === 'platform' }" href="#" @click.prevent="collection = 'platform'">Platform</a>
            <a :class="{ active: collection === 'flow' }" href="#" @click.prevent="collection = 'flow'">Flow</a>
        </template>

        <template #body>
            <v-alert :message="error" />
            <div class="actions">
                <v-action v-for="a in filteredActions"
                    :key="a.type"
                    :action="a"
                    :loading="loading === a.type"
                    @click.native="createAction(a.type)">
                </v-action>
            </div>
         </template>

        <template #footer>
            <v-button size="sm" btn-style="white" @click.native="cancel">Cancel</v-button>
            <div></div>
        </template>

    </v-modal>

</template>

<script>

import ActionApi from '@api/ActionApi';

export default {

    data() {
        return {
            loading: false,
            error: null,
            collection: null,
        }
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

        actions() {
            return [
                { name: 'Email', desc: 'Send an email', type: 'email', collection: ['messages', 'popular', 'broadcast'] },
                { name: 'Delay', desc: 'Add a time delay', type: 'delay', collection: ['flow', 'popular'] },
                { name: 'Condition', desc: 'Add a condition', type: 'condition', collection: ['flow', 'popular'] },
                { name: 'Tag', desc: 'Tag a customer', type: 'tag', collection: ['platform', 'popular'] },
                { name: 'ShoutOUT', desc: 'Send a text message', type: 'shoutout', collection: ['messages'] },
                { name: 'Twilio', desc: 'Send a text message', type: 'twilio', collection: ['messages'] },
                { name: 'Slack', desc: 'Notify your team', type: 'slack', collection: ['alerts', 'popular'] },
                { name: 'Discord', desc: 'Notify your team', type: 'discord', collection: ['alerts', 'popular'] },
                { name: 'Push Notification', desc: 'Send a web push notification', type: 'push', collection: ['alerts', 'popular', 'broadcast'] },
                { name: 'Zapier', desc: 'Notify another application', type: 'zapier', collection: ['alerts'] },
                { name: 'Webhook', desc: 'Notify your application', type: 'webhook', collection: ['alerts'] },
            ];
        },

        filteredActions() {
            return this.actions.filter(a => {
                return !this.collection || a.collection.includes(this.collection);
            });
        },

    },

    mounted() {
        this.collection = this.campaign.type === 'broadcast' ? 'broadcast' : 'popular';
    },

    methods: {

        createAction(type) {
            this.loading = type;
            ActionApi.createAction(this.campaign.id, { type: type })
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('campaign/addAction', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                    this.$store.commit('showModal', false);
                })
                .catch((error) => {
                    this.loading = false;
                    this.error = error.response.data.message
                });
        },

        cancel() {
            this.$store.commit('showModal', false);
        },

    },

}

</script>
